import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  LocationDto,
  LocationListDto,
  LocationFilterDto,
  CreateLocationRequest,
  UpdateLocationRequest,
} from '@/types/location.types';

export const locationApi = {
  /** GET /api/v1/locations — paginated list with optional search/filter */
  getList: (filter?: LocationFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<LocationListDto>>>('/locations', {
      params: filter,
    }),

  /** GET /api/v1/locations/{id} — full location record */
  getById: (id: string) =>
    apiClient.get<ApiResponse<LocationDto>>(`/locations/${id}`),

  /** GET /api/v1/locations/by-code/{code} — returns 404 when not found */
  getByCode: (code: string) =>
    apiClient.get<ApiResponse<LocationDto>>(
      `/locations/by-code/${encodeURIComponent(code)}`,
    ),

  /** POST /api/v1/locations — create a new location */
  create: (data: CreateLocationRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/locations', data),

  /** PUT /api/v1/locations/{id} — update location details */
  update: (id: string, data: UpdateLocationRequest) =>
    apiClient.put<ApiResponse<object>>(`/locations/${id}`, data),

  /** DELETE /api/v1/locations/{id} — soft-delete the location */
  remove: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/locations/${id}`),
};
